import { GRID_MAX_DIST, GRID_RES } from "./constants";
/** Step 1: derive the group's local axes — x along its alignment, y perpendicular (90° CCW). */
export function getGroupAlignmentAxes(group) {
    const { dx, dy } = group.orientation;
    return {
        x: { dx, dy },
        y: { dx: -dy, dy: dx },
    };
}
/** Projects a world-space point onto the group's local (x, y) axes. */
export function projectToLocal(point, axes) {
    const [px, py] = point;
    const localX = px * axes.x.dx + py * axes.x.dy;
    const localY = px * axes.y.dx + py * axes.y.dy;
    return [localX, localY];
}
/** Converts a local (x, y) coordinate back to world space — the inverse of projectToLocal. */
export function localToWorld(point, axes) {
    const [lx, ly] = point;
    const worldX = lx * axes.x.dx + ly * axes.y.dx;
    const worldY = lx * axes.x.dy + ly * axes.y.dy;
    return [worldX, worldY];
}
/**
 * Step 2: computes the local-frame x/y range to search for prospective grid
 * lines — the foundations' local bounding box, expanded by GRID_MAX_DIST on
 * every side (plus one GRID_RES step on the high end, so the max grid line
 * position itself falls within range).
 */
export function getGroupGridSearchSpace(group) {
    const axes = getGroupAlignmentAxes(group);
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (const foundation of group.foundations) {
        for (const point of foundation.points) {
            const [localX, localY] = projectToLocal(point, axes);
            minX = Math.min(minX, localX);
            maxX = Math.max(maxX, localX);
            minY = Math.min(minY, localY);
            maxY = Math.max(maxY, localY);
        }
    }
    return {
        axes,
        xRange: { min: minX - GRID_MAX_DIST, max: maxX + GRID_MAX_DIST + GRID_RES },
        yRange: { min: minY - GRID_MAX_DIST, max: maxY + GRID_MAX_DIST + GRID_RES },
    };
}
